import { ClickEvent, MapPin } from "@mcleod/components";
import { PinPlotEvent } from "@mcleod/components/src/components/map/PinPlotEvent";
import { CityUtil, getThemeColor, ModelRow, getMapSettings } from "@mcleod/core";
import { AutogenLayoutFtlOrderConfirmation } from "./autogen/AutogenLayoutFtlOrderConfirmation";
import { ShareOrder } from "./ShareOrder";

export class FtlOrderConfirmation extends AutogenLayoutFtlOrderConfirmation {
  private key: string;

  override async onLoad() {

    if (this.__designer == null && this.key != null) {
      this.panelRight.visible = false;
      await this.mainDataSource.search({ id: this.key}).then(() => {
        this.layoutHeader.displayHoldPanel(this.activeRow.get("hold_warning"));
      })
      this.panelRight.visible = true;
      const distanceCalcVendor = getMapSettings()?.distance_calc_vendor;
      if (distanceCalcVendor == "N") {
        this.mapStops.visible = false;
      }
    }

    this.mapStops.addPinPlotListener((event: PinPlotEvent) => {
      const pin: MapPin = event.pin;
      pin.caption = "" + pin.data.get("order_sequence");
      pin.clusterable = false;
      pin.image = "map-pin-white-dot-large";
      pin.tooltip = this.getMapPinToolTip(pin.data);
      pin.captionColor = getThemeColor("primary");
  });
}

  private getMapPinToolTip(data:ModelRow) : string {
    const cityStateZip = CityUtil.formatCityStateZip(data.get("city_name"), data.get("state"), data.get("zip_code"));
    return `Stop ${data.get("order_sequence")}: ${cityStateZip}`;
  }

  buttonShareOnClick(event: ClickEvent) {
    ShareOrder.onClick(event, this.activeRow.get("id"));
  }
}
